import React, { useRef, useState } from "react";
import { Button, Card, Row, Col, Alert } from "react-bootstrap";
import styled from "styled-components";
import constantFunc from "../../../constant/constantFunc";
import parse from "html-react-parser";
import {
  pastoralSummaryPdf,
  updateAppoinment,
  updateAppoinmentStatus,
} from "../../../api/apiHandler";
import Swal from "sweetalert2";
import queryString from "query-string";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useMeetingManager } from "amazon-chime-sdk-component-library-react";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import clergyconstantFunc from "../../../constant/clergyConstant";
const PriestMeetingRecord = ({
  medicineList,
  handleQRCode,
  handlePatientEditInfo,
  isOpenMailModal,
  handlePatientInfo,
  meetingData,
  from,
  type,
  settypepres,
  fromEmailMeetingId,
}) => {
  const [reportText, setReportText] = useState(null);
  const newTabRef = useRef(null);
  const meetingManager = useMeetingManager();
  let navigate = useNavigate();
  let location = useLocation();
  const { interimTranscript, resetTranscript, transcript, listening } =
    useSpeechRecognition();
  const loginType = parseInt(localStorage.getItem("user_login_type_role"));
  console.log(reportText, "location42322dattattaa");

  const goBackToParent = () => {
    console.log(window.opener, "windowsssss");

    if (window.opener && !window.opener.closed) {
      // window.opener.focus();
      const joinMeetingObj = {
        meeting_id: meetingData?.meeting_id
          ? meetingData?.meeting_id
          : meetingData?.uuid
          ? meetingData?.uuid
          : meetingId
          ? meetingId
          : fromEmailMeetingId,
        appointment_id: meetingData?.appointment_id,

        user_id: localStorage.getItem("user_id"),
        name: localStorage.getItem("user_name"),
        email: localStorage.getItem("user_email"),
        role: parseInt(localStorage.getItem("user_login_type_role")),
        start_meeting: 0,
        ongoing_meet: true,
      };
      navigate(
        window.opener.location.pathname + window.opener.location.search,
        { state: joinMeetingObj }
      );
    } else {
      alert("No parent window found!");
    }
  };

  const handleUpdateStatus = async () => {
    const updateStatusObj = {
      appointment_id: meetingData?.appointment_id,
      appointment_status: process.env.REACT_APP_MEETING_DONE,
    };
    let response;
    if (loginType == 2 || loginType == 4) {
      response = await updateAppoinmentStatus(updateStatusObj);
    } else {
      response = await updateAppoinment(updateStatusObj);
    }
  };
  const confirmExitMeeting = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to exit the meeting?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, exit",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      exitMeeting();
    }
  };

  const exitMeeting = async (shouldNavigate = true) => {
    if (location.pathname == "/priest/auto-prescription") {
      handleUpdateStatus();
    }
    await meetingManager.leave();
    SpeechRecognition.stopListening();
    localStorage.removeItem("meeting_room");
    if (shouldNavigate) navigate("/");
  };

  const [showFull, setShowFull] = useState(true); // toggle state

  console.log(medicineList, "newText23wss322xaleo");
  const handleReadReport = async () => {
    if (Array.isArray(medicineList) && medicineList?.length > 0) {
      let newText = await clergyconstantFunc.convertMarkdownLinksToHTML(
        medicineList[0]?.pastoral_summary
      );

      if (showFull) {
        // show full text
        setReportText(newText);
      } else {
        // show half text
        const halfLength = Math.floor(newText?.length / 8);
        setReportText(newText?.substring(0, halfLength) + "...");
      }

      // toggle state
      setShowFull(!showFull);
    } else {
      setReportText(null);
    }
  };

  console.log(reportText, "reportTextsssss");

  const params = queryString.parse(window.location.search);
  console.log(meetingData, "Autopres456fcription12response");
  const { meetingId } = useParams();
  const handleDownloadPdf = async () => {
    Swal.fire({
      title: "Please wait...",
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      let response = await pastoralSummaryPdf({
        meeting_id: meetingData?.meeting_id
          ? meetingData?.meeting_id
          : meetingData?.uuid
          ? meetingData?.uuid
          : meetingId
          ? meetingId
          : fromEmailMeetingId,
      });

      // safely parse if string
      let parsedResponse;
      try {
        parsedResponse =
          typeof response === "string" ? JSON.parse(response) : response;
      } catch (err) {
        throw new Error("Invalid JSON response");
      }

      console.log("Autoprescription12response", parsedResponse);

      if (parsedResponse?.data?.url) {
        const link = document.createElement("a");
        Swal.close();
        link.href = parsedResponse.data.url;
        link.setAttribute("download", "Pastoral_Report.pdf"); // filename
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        Swal.fire({
          icon: "error",
          title: "PDF not available",
          text: parsedResponse?.message || "Something went wrong",
        });
      }
    } catch (error) {
      console.error("Error downloading PDF:", error);
      Swal.fire({
        icon: "error",
        title: "Download failed",
        text: error.message || "Please try again later",
      });
    }
  };

  const handleChangeShowQR = async () => {
    Swal.fire({
      title: "Please wait...",
      didOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      let response = await pastoralSummaryPdf({
        meeting_id: meetingData?.meeting_id
          ? meetingData?.meeting_id
          : meetingData?.uuid
          ? meetingData?.uuid
          : meetingId
          ? meetingId
          : fromEmailMeetingId,
      });

      // safely parse if string
      let parsedResponse;
      try {
        parsedResponse =
          typeof response === "string" ? JSON.parse(response) : response;
      } catch (err) {
        throw new Error("Invalid JSON response");
      }

      console.log("Autoprescription12response", parsedResponse);

      if (parsedResponse?.data?.url) {
        const link = document.createElement("a");
        Swal.close();
        link.href = parsedResponse.data.url;
        if (parsedResponse.data.url) {
          handleQRCode();
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "PDF not available",
          text: parsedResponse?.message || "Something went wrong",
        });
      }
    } catch (error) {
      console.error("Error downloading PDF:", error);
      Swal.fire({
        icon: "error",
        title: "Download failed",
        text: error.message || "Please try again later",
      });
    }
  };
  console.log(medicineList, "medicineLis444retsss");

  return (
    <div className="">
      <div
        className="content text-black mb-2 d-flex align-items-center position-relative"
        style={{ fontFamily: "Aharoni" }}
      >
        <Button
          className="submit-btn "
          style={{ width: "unset" }}
          onClick={handleReadReport}
          size="sm"
        >
          Read Report
        </Button>

        <h2
          className="m-0 fw-bold text-center flex-grow-1"
          style={{
            color: "#216fc8",
          }}
        >
          {meetingData?.prescriptionType === "tempPres" || type == "tempPres"
            ? "Draft Pastoral Report"
            : "Pastoral Report"}
        </h2>
      </div>

      <div className="table-responsive">
        <table className="doctor-list-table table table-bordered">
          <tbody>
            <tr>
              <td>
                <pre
                  id="scripture-block"
                  className="mb-2 text-justify white-space-pre"
                  dangerouslySetInnerHTML={{
                    __html: reportText,
                  }}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <PocPrescriptionWrpper className="d-flex mt-3 align-items-center justify-content-between flex-wrap gap-3">
        <button
          // disabled
          onClick={handleChangeShowQR}
          className="submit-btn d-inline-flex justify-content-center "
          style={{ maxWidth: "max-content" }}
        >
          QR Codes
        </button>
        <Col xs="auto">
          <Button
            className="submit-btn "
            style={{ width: "unset" }}
            onClick={handleDownloadPdf}
          >
            Print (also to pdf.)
          </Button>
        </Col>

        <button
          disabled
          //   onClick={handleQRCode}
          className="submit-btn d-inline-flex justify-content-center disabled"
          style={{ maxWidth: "max-content" }}
        >
          Pastoral Report
        </button>
        <button
          disabled={
            location.pathname.startsWith(
              "/priest/meeting-single-user-record/"
            ) || location.pathname == "/priest/auto-prescription-starpilot"
          }
          className={`submit-btn d-inline-flex justify-content-center 
            
            ${
              (location.pathname.startsWith(
                "/priest/meeting-single-user-record/"
              ) ||
                location.pathname == "/priest/auto-prescription-starpilot") &&
              "disabled"
            }
          `}
          onClick={() => {
            handlePatientInfo();
            if (
              meetingData?.prescriptionType === "tempPres" ||
              type == "tempPres"
            ) {
              settypepres("temp-prescription");
            } else {
              settypepres("prescription");
            }
          }}
          style={{ maxWidth: "max-content" }}
        >
          Patient Info
        </button>

        <button
          onClick={() => isOpenMailModal(medicineList)}
          className={`${
            reportText == null && "disabled"
          } submit-btn d-inline-flex justify-content-center `}
          style={{
            maxWidth: "max-content",
          }}
          disabled={reportText == null}
          // disabled
        >
          Mail Report
        </button>

        <button
          disabled={
            loginType !== 3 &&
            loginType !== 4 &&
            !location.pathname.startsWith("/patient/meeting-record")
          }
          className={`submit-btn d-inline-flex justify-content-center 
           
             ${
               loginType !== 3 &&
               loginType !== 4 &&
               !location.pathname.startsWith("/patient/meeting-record") &&
               "disabled"
             }
          `}
          onClick={() => {
            handlePatientEditInfo();
            if (
              meetingData?.prescriptionType === "tempPres" ||
              type == "tempPres"
            ) {
              settypepres("temp-prescription");
            } else {
              settypepres("prescription");
            }
          }}
          style={{ maxWidth: "max-content" }}
        >
          Clergy Info
        </button>
        {/* {(meetingData?.from === "singleUser" ||
          location.pathname == "/priest/auto-prescription") && (
          <button
            onClick={goBackToParent}
            style={{
              maxWidth: "max-content",
            }}
            className={`submit-btn singleUser d-inline-flex justify-content-center `}
          >
            Go Back
          </button>
        )}

        {(meetingData?.from === "singleUser" ||
          location.pathname == "/priest/auto-prescription") && (
          <button
            onClick={confirmExitMeeting}
            // style={{
            //   maxWidth: "max-content",
            // }}
            className="btn btn-danger px-3"
          >
            Exit
          </button>
        )} */}
        {(meetingData?.from === "singleUser" ||
          location.pathname == "/priest/auto-prescription") && (
          <div className="d-flex justify-content-center fixed-bottom mb-3 gap-3">
            <button
              className="btn btn-primary d-flex align-items-center gap-2"
              onClick={goBackToParent}
            >
              Back
            </button>
            <button
              className="btn btn-danger d-flex align-items-center gap-2"
              onClick={confirmExitMeeting}
            >
              Exit
            </button>
          </div>
        )}
      </PocPrescriptionWrpper>
    </div>
  );
};
const PocPrescriptionWrpper = styled.div`
  @media (max-width: 480px) {
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
    button {
      width: 100%;
      max-width: 100% !important;
    }
  }
`;
export default PriestMeetingRecord;
